import { LegalLayout, H2, P, UL } from "@/components/LegalLayout";

export default function Cookies() {
  return (
    <LegalLayout title="Política de Cookies" updated="2026" testid="page-cookies">
      <P>Este sitio utiliza cookies conforme al RGPD, la LOPDGDD y la Ley 34/2002 (LSSI-CE). A continuación te explicamos qué son y cómo las usamos.</P>

      <H2>1. ¿Qué son las cookies?</H2>
      <P>Son pequeños archivos que se almacenan en tu dispositivo al navegar y que permiten recordar información sobre tu visita.</P>

      <H2>2. Tipos de cookies que usamos</H2>
      <UL>
        <li><b>Técnicas (necesarias):</b> imprescindibles para el funcionamiento del sitio y la sesión de usuario (inicio de sesión). No requieren consentimiento.</li>
        <li><b>Analíticas:</b> Google Analytics (identificador G-7YXRGVN7Z0) para medir el uso del sitio de forma agregada. Requieren tu consentimiento.</li>
      </UL>

      <H2>3. Gestión del consentimiento</H2>
      <P>Al entrar por primera vez mostramos un aviso donde puedes <b>aceptar</b> o <b>rechazar</b> las cookies no necesarias. Puedes cambiar tu elección en cualquier momento borrando las cookies de tu navegador o desde el propio aviso.</P>

      <H2>4. Cómo desactivarlas</H2>
      <P>Puedes bloquear o eliminar las cookies desde la configuración de tu navegador (Chrome, Firefox, Safari, Edge). Ten en cuenta que desactivar las técnicas puede afectar al funcionamiento del sitio.</P>

      <H2>5. Más información</H2>
      <P>Para dudas sobre esta política escribe a contacto@cyvrlabs.com.</P>
    </LegalLayout>
  );
}
